import DateFnsAdapter from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import Router from './components/Router'
import { ConfirmProvider } from './contexts/ConfirmContext'

import { AuthProvider } from './hooks/useAuth'
import theme from './utils/theme'

export default function App(): JSX.Element {
  return (
    <React.Suspense fallback="">
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={DateFnsAdapter}>
            <HelmetProvider>
              <QueryClientProvider client={queryClient}>
                <CssBaseline />
                <ConfirmProvider>
                  <Router />
                </ConfirmProvider>
                <ReactQueryDevtools />
              </QueryClientProvider>
            </HelmetProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </AuthProvider>
    </React.Suspense>
  )
}

const queryClient = new QueryClient()
